type HiddenProps = {
  unless: boolean;
  children: React.ReactNode;
};

const Hidden = ({ unless, children }: HiddenProps) => {
  return <div className={unless ? "" : "hidden"}>{children}</div>;
};

export default Hidden;
